import React, { memo } from 'react';

import { Box, Skeleton, useMediaQuery } from '@mui/material';
import { NoAvailableMessageContent } from 'app/shared/components/common/NoAvailableMessage';
import PropTypes from 'prop-types';

import { BASE_YEAR, COLUMNS_LARGE_SCREEN, COLUMNS_SMALL_SCREEN } from './BadgesWrapper.constants';

const getWrapperStyles = ({ numberOfColumns }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`,
  gap: '24px',
});

const BadgesWrapper = ({ isDataLoading, data, skeletonHeight, children }) => {
  const numberOfColumns = useMediaQuery(theme => theme.breakpoints.down(BASE_YEAR))
    ? COLUMNS_SMALL_SCREEN
    : COLUMNS_LARGE_SCREEN;

  return (
    <>
      <Box sx={getWrapperStyles({ numberOfColumns })}>
        {isDataLoading &&
          Array.from({ length: numberOfColumns }, (_, index) => (
            <Skeleton height={skeletonHeight} key={index} variant="rounded" />
          ))}

        {!isDataLoading && !!data.length && children}
      </Box>

      {!isDataLoading && !data.length && <NoAvailableMessageContent message="No results" />}
    </>
  );
};

BadgesWrapper.propTypes = {
  isDataLoading: PropTypes.bool.isRequired,
  skeletonHeight: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
};

export default memo(BadgesWrapper);
